import { Button } from "../styles/Button.styled";

export const docPageHeader = (t) => t("We are Almost There!");
export const docPageSubHeader = (t) =>
  t(
    "Your application for service with CleanSky Energy has been placed on hold, pending verification of your information. Your service will not start until such time as your information can be validated."
  );
export const renderDepositWaiverSuccess = (tCommon) => (
  <div
    style={{
      color: "green",
      textAlign: "center",
      backgroundColor: "#eff7fa",
      padding: "10px",
      borderRadius: "10px",
      fontWeight: "bold",
    }}
  >
    {tCommon("thankYouText")}
  </div>
);

export const RenderUploadFooter = ({
  setCancelled,
  setUploadCancelled,
  handleSubmit,
  payDepositButton,
  t,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "1rem",
        gap: 16,
      }}
    >
      <Button onClick={handleSubmit} style={{ minWidth: 150 }}>
        {t("upload")}
      </Button>
      {payDepositButton ? (
        payDepositButton()
      ) : (
        <Button
          onClick={() =>
            // one of the setCancelled state must be passed always, the setCancelled renders a screen from parent componennet, and the setUploadCancelled just appends the text
            setCancelled ? setCancelled(true) : setUploadCancelled(true)
          }
          style={{
            marginRight: "1rem",
            background: "transparent",
            color: "#253f66",
          }}
        >
          {t("cancel")}
        </Button>
      )}
    </div>
  );
};
